export const charactersOnly = /^[a-zA-Z]+$/;
export const charactersWithSpaces = /^[a-zA-Z ]+$/;
export const numbersOnly = /^[0-9]+$/;
export const minNameCharacters = 4;
export const identificationNumber = /^[a-zA-Z0-9]+$/;
export const zipcode = /^[a-zA-Z0-9\s\-]{4,8}$/;
export const phoneNumber = /^[0-9]{10}$/;
